import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_123: FaireProductEntity = {
  token: "starter_collection_123",
  type: "product",
  name: "Ghia Jigsaw Puzzles",
  brandName: "Ghia",
  imageUrl:
    '"https://cdn.faire.com/fastly/e54f9a85a64343b7180db4b9678b68152e006c20ef34f018c987da70ef62ef0b.jpeg?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=1456',
  priceDollars: 36,
  msrpDollars: 72,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
